// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/alicebg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Main Layout Scss File 
 */
body, html {
  font-family: "Source Sans Pro";
  margin: 0px;
  padding: 0px;
}

body,
.page {
  display: flex;
  min-height: 100vh;
  flex-direction: row;
  font-size: 1.4rem;
}

#app {
  width: 100%;
}

.page header {
  margin-top: 50px;
}

.page-body {
  display: flex;
  flex: 1 1;
}

.page-content {
  display: flex;
  flex: 1 0;
  flex-direction: column;
  background: #f4f5f7;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 95% 95%;
  background-attachment: fixed;
  background-repeat: no-repeat;
  padding: 0px;
  margin: 0px;
}

.main-content-wrapper {
  flex: 1 1;
}

.page-footer {
  flex: 0 1;
  padding: 3px;
}
.page-footer a {
  font-size: 12px;
  text-decoration: none;
}

.page-nav {
  flex: 0 0 250px;
  order: -1;
  background: #f8f8f8;
}

.page-sidebar {
  flex: 0 0 195px;
  background: #222;
}

@media (min-width: 1300px) {
  .page-sidebar {
    flex: 0 0 230px;
    background: #222;
  }
}
header {
  flex: none;
}

.navbar {
  box-shadow: none;
  border-bottom: none;
}

.page-header {
  line-height: 59px;
  background: white;
  margin: 0px;
  height: 59px;
}

.table-protocols .protocol-state-error {
  display: block;
  font-size: 11px;
  color: orange;
}

.loading-indicator {
  text-align: center;
  width: 50px;
  margin: 0px auto;
}

.details-main {
  margin-right: 0px;
  margin-top: 20px;
}
.details-main .help-block {
  margin: 20px;
  padding: 10px 5px;
}
.details-main.row {
  margin: 0px;
}

.jumbotron {
  padding: 20px;
  border-bottom: 3px solid red;
}

.central {
  display: flex;
  min-height: 75vh;
  align-items: center;
}
.central h1 {
  text-align: center;
  flex: 1 1;
  color: #777;
  text-shadow: 0px -1px 0px #000000;
}

/*
 * HEADER
 */
.page-sidebar {
  color: #f0f0f0;
}
.page-sidebar h2 {
  color: #b0b0b0;
  margin-top: 15px;
  font-size: 12px;
  text-transform: uppercase;
  padding-left: 15px;
}
.page-sidebar .sidebar-header {
  color: #f0f0f0;
  display: flex;
  flex-direction: row;
  background: #0867af;
  justify-content: center;
  align-items: center;
  padding: 10px 15px;
  height: 58px;
}
.page-sidebar .sidebar-header .logo {
  flex: 0 0 50px;
  padding: 10px 15px;
  background-color: #222;
  border-radius: 16px 16px 0px 0px;
  margin-right: 12px;
}
.page-sidebar .sidebar-header .logo .logo-icon {
  margin-top: 5px;
}
.page-sidebar .sidebar-header .title {
  flex: 1 1;
  padding-top: 10px;
}
.page-sidebar .sidebar-header .title h1 {
  margin: 7px 0px 0px 0px;
  padding: 3px 0px;
  font-size: 13px;
  color: #f0f0f0;
}
.page-sidebar .sidebar-header .title p {
  font-size: 10px;
  color: #f0f0f0;
}
.page-sidebar .routeservers-list {
  margin-top: 40px;
}
.page-sidebar .routeservers-list > ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.page-sidebar .routeservers-list > ul li {
  padding: 8px;
  padding-left: 15px;
  cursor: pointer;
}
.page-sidebar .routeservers-list .routeserver-id {
  font-size: 13px;
  display: block;
}
.page-sidebar .routeservers-list a.routeserver-id {
  text-decoration: none;
}
.page-sidebar .routeservers-list a.routeserver-id:hover {
  text-decoration: underline;
}
.page-sidebar .routeservers-list .routeserver-status .bird-version {
  font-size: 10px;
  color: #888888;
}
.page-sidebar .routeservers-list .routeserver-status .api-error {
  font-size: 10px;
  color: #aa0000;
}
.page-sidebar .routeservers-groups-select {
  display: block;
  padding: 0px 3px;
}
.page-sidebar .routeservers-groups-select .dropdown .dropdown-menu {
  display: block;
}
.page-sidebar .routeservers-groups-select .rs-group-dropdown .dropdown-options {
  display: none;
}
.page-sidebar .routeservers-groups-select .rs-group-dropdown.open .dropdown-options {
  display: flex;
}
.page-sidebar .routeservers-groups-select .dropdown-options {
  position: absolute;
  z-index: 999;
  background: #fbfbfb;
  border-radius: 4px;
  box-shadow: 2px 2px 3px #aaa;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.page-sidebar .routeservers-groups-select .dropdown-options ul {
  flex: 1 1;
  margin: 0;
  padding: 15px;
}
.page-sidebar .routeservers-groups-select .dropdown-options li {
  padding: 3px;
  list-style: none;
  border-radius: 4px;
}
.page-sidebar .routeservers-groups-select .dropdown-options li button {
  border-radius: 3px;
  padding: 3px 8px;
}
.page-sidebar .routeservers-groups-select .dropdown-options li button:hover {
  color: #337ab7;
}
.page-sidebar .routeservers-groups-select .btn-select {
  display: block;
  width: 100%;
  background: #2661a5;
  border: #2661a5;
  text-align: left;
  color: white;
  text-shadow: none;
}
.page-sidebar .routeservers-groups-select .btn-select .caret {
  float: right;
  margin-top: 10px;
}
.page-sidebar .routeservers-groups-select .btn-select:focus, .page-sidebar .routeservers-groups-select .btn-select:hover {
  background: #2661a5;
  color: white;
  text-shadow: none;
}
.page-sidebar .routeservers-groups-select .btn-select:focus {
  box-shadow: 0px 1px 0px #555;
}
.page-sidebar .routeservers-groups-select .btn-option {
  display: block;
  text-align: left;
  color: #2661a5;
  width: 100%;
  padding: 2px 10px;
}
.page-sidebar .routeservers-groups-select .btn-option:hover {
  background: #ccc;
  text-decoration: none;
}

.page-header {
  display: flex;
  align-items: center;
  min-height: 72px;
  height: auto;
  padding: 12px 20px;
  border-bottom: 1px solid #e2e8f0;
  border-radius: 8px;
}
.page-header .status-name {
  font-weight: bold;
}
.page-header .status-protocol {
  font-weight: bold;
}
.page-header .spacer {
  font-weight: bold;
  padding: 0px 8px;
}
.page-header h1 {
  margin: 0;
  color: #17202a;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.25;
}
.page-header p {
  margin: 4px 0 0;
  color: #667085;
  font-size: 14px;
  line-height: 1.4;
}

.routeserver-status {
  margin: 0px;
  padding: 0px;
}
.routeserver-status td {
  vertical-align: top;
  padding: 4px;
}
.routeserver-status td i {
  width: 15px;
}

.card {
  position: relative;
  background: white;
  margin: 20px 0px 20px 0px;
  border-radius: 2px;
  box-shadow: 0px 1px 3px #cccccc;
  padding: 15px;
}

.card-header {
  text-transform: uppercase;
}

/**
 * Show Modal
 */
.modal-show {
  display: block;
}
.modal-show .modal-content {
  border-radius: 3px;
}

.modal-dialog .modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.bgp-attributes-modal .modal-header p {
  margin: 0px;
  font-size: 10px;
}
.bgp-attributes-modal .modal-header h4 {
  font-size: 14px;
  margin: 0px;
}
.bgp-attributes-modal table th {
  width: 142px;
}

.table-nolines td, .table-nolines th {
  border: none !important;
}

.col-neighbor-attr {
  white-space: nowrap;
}
.col-neighbor-attr a, .col-neighbor-attr a:link, .col-neighbor-attr a:active {
  color: #333;
}
.col-neighbor-attr i.fa {
  color: #333;
}

.col-neighbor-active {
  font-weight: bold;
  color: #2e6da4;
}

.neighbors-quick-links {
  margin: -0.75em 0;
  text-align: right;
}
.neighbors-quick-links span {
  color: #888;
}
.neighbors-quick-links ul {
  padding: 0px;
  margin: 0px;
  display: inline-block;
}
.neighbors-quick-links li {
  display: inline-block;
  padding: 0px 4px;
  margin: 0px 0px 0px 8px;
  background: white;
  border-radius: 3px;
}
.neighbors-quick-links li.established a {
  color: green;
}
.neighbors-quick-links li.down a {
  color: red;
}

.card-header-neighbors.established {
  color: green;
}
.card-header-neighbors.down {
  color: red;
}
@keyframes fadeSmooth {
  from {
    opacity: 0;
    left: -90px;
  }
  to {
    opacity: 1;
    left: -70px;
  }
}
.table-routes tr {
  position: relative;
}
.table-routes td {
  color: #337ab7;
  text-decoration: none;
}
.table-routes td span:hover {
  text-decoration: underline;
}
.table-routes td span {
  cursor: pointer;
}
.table-routes .noexport-reason,
.table-routes .reject-reason {
  font-size: 90%;
  color: #333;
  margin-bottom: 1px;
}
.table-routes .noexport-reason a,
.table-routes .reject-reason a {
  color: #aa0000;
}
.table-routes .col-route-flags {
  padding-left: 2px;
  width: auto;
  white-space: nowrap;
}
.table-routes .col-route-flags i {
  font-style: normal;
}
.table-routes .route-prefix-flags .primary-route {
  color: #efb208;
}
.table-routes .route-prefix-flags .rpki-valid {
  color: #009900;
}
.table-routes .route-prefix-flags .rpki-invalid {
  color: #d80000;
}
.table-routes .route-prefix-flags .rpki-unknown {
  color: #2e6da4;
}
.table-routes .route-prefix-flags .rpki-not-checked {
  color: #2e6da4;
}
.table-routes .route-prefix-flags .reject-candidate-route {
  color: #d80000;
}
.table-routes .route-prefix-flag {
  color: #555;
  text-decoration: none;
  border: none;
  font-size: 10px;
  cursor: default;
  padding-left: 3px;
}
.table-routes .route-prefix-flag div {
  font-size: 12px;
  display: none;
  left: -90px;
  background: rgba(0, 0, 0, 0.45);
  color: white;
  position: absolute;
  padding: 5px;
  margin-top: -22px;
  border-radius: 3px;
  font-weight: bold;
  animation-name: fadeSmooth;
}
.table-routes .route-prefix-flag:hover {
  text-decoration: none;
}
.table-routes .route-prefix-flag:hover div {
  display: block;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
.table-routes .route-network {
  display: inline-block;
  position: relative;
  width: 100%;
  white-space: nowrap;
}
.table-routes .route-age {
  white-space: nowrap;
}

.table-protocols {
  background: white;
}
.table-protocols .date-since {
  white-space: nowrap;
}

.routes-loading.card p {
  font-family: monospace;
  font-size: 12px;
}

.routes-header-container {
  text-decoration: none;
}
.routes-header-container a:hover {
  text-decoration: none;
}

.routes-quick-links {
  margin: -0.75em 0;
  text-align: right;
}
.routes-quick-links span {
  color: #888;
}
.routes-quick-links ul {
  padding: 0px;
  margin: 0px;
  display: inline-block;
}
.routes-quick-links li {
  display: inline-block;
  padding: 0px 4px;
  margin: 0px 0px 0px 8px;
  background: white;
  border-radius: 3px;
}
.routes-quick-links li.filtered a {
  color: orange;
}
.routes-quick-links li.received a {
  color: green;
}
.routes-quick-links li.not-exported a {
  color: red;
}

/*
 * Related Peers
 */
.related-peers {
  display: block;
  position: absolute;
  overflow: hidden;
  padding: 3px 3px 0px 3px;
  margin: 0px;
  list-style: none;
  top: -26px;
}
.related-peers li {
  height: 23px;
  line-height: 23px;
  display: inline-block;
  padding: 0px 5px;
  margin: 0px 10px 0px 0px;
  border-bottom: 1px solid #ffffff;
  background: #ffffff;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  box-shadow: 0px 1px 3px #aaa;
}
.related-peers li.active {
  font-weight: bold;
}
.related-peers li.active a {
  color: #2661a5;
}
.related-peers li a, .related-peers li a:hover {
  text-decoration: none;
}

.has-related-peers .details-main {
  padding-top: 21px;
}

.card-header-routes.received {
  color: green;
}
.card-header-routes.filtered {
  color: orange;
}
.card-header-routes.not-exported {
  color: red;
}

.routes-view.routes-filtered .route-prefix-flag.reject-candidate-route {
  display: none;
}
@media (min-width: 1200px) and (max-width: 1258px) {
  .details-main > .col-main {
    width: 80%;
    float: left;
  }
  .details-main > .col-aside-details {
    width: 20%;
    float: left;
  }
}
.card-related-peers h2 {
  color: #555;
  font-weight: bold;
  margin-top: 8px;
  margin-bottom: 5px;
  font-size: 12px;
  text-transform: uppercase;
  padding: 0;
}
.card-related-peers h3 {
  font-size: 14px;
  margin: 10px 0px 0px 0px;
  padding-bottom: 2px;
  border-bottom: 1px solid #ccc;
  color: black;
}
.card-related-peers .related-peers-rs-peer {
  margin: 5px 0px;
  width: 100%;
}
.card-related-peers table {
  width: 100%;
}
.card-related-peers .uptime {
  text-align: right;
}
.card-related-peers .peer-stats {
  text-align: center;
  cursor: default;
}
.card-related-peers .peer-stats .routes-received {
  color: green;
}
.card-related-peers .peer-stats .routes-accepted {
  color: green;
}
.card-related-peers .peer-stats .routes-filtered {
  color: orange;
}
.atooltip {
  position: relative;
  display: inline-block;
  cursor: default;
}

.atooltip i {
  position: absolute;
  font-style: normal;
  width: 140px;
  color: #ffffff;
  background: #000000;
  height: 30px;
  line-height: 30px;
  text-align: center;
  visibility: hidden;
  border-radius: 6px;
}

.atooltip i:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -8px;
  width: 0;
  height: 0;
  border-top: 8px solid #000000;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
}

.atooltip:hover i {
  visibility: visible;
  opacity: 0.8;
  bottom: 30px;
  left: 50%;
  margin-left: -76px;
  z-index: 999;
}

.error-notify {
  width: 420px;
  border-bottom: 7px solid #7c0002;
  background-color: rgba(255, 0, 0, 0.8);
  color: #fff;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  display: table;
  z-index: 999;
  right: 30px;
  top: 20px;
}
.error-notify .error-icon {
  display: table-cell;
  width: 60px;
  padding: 8px 10px 0 10px;
  text-align: center;
  vertical-align: top;
}
.error-notify .error-icon > i {
  font-size: 3em;
  border-radius: 100%;
}
.error-notify .error-message {
  display: table-cell;
}
.error-notify .error-message > p {
  line-height: 1.2;
  margin-top: 6px;
}
.error-notify .error-dismiss {
  position: absolute;
  right: 5px;
  top: 0px;
  cursor: pointer;
}

.lookup-container h2 {
  text-transform: uppercase;
  color: #337ab7;
  font-size: 14px;
  line-height: 1;
  margin-top: 0px;
}

.lookup-result-summary ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.lookup-result-summary li {
  padding: 5px 0;
}

.lookup-help {
  margin: 30px 20px;
}
.lookup-help h3 {
  font-weight: normal;
  font-style: italic;
  color: #337ab7;
  margin-top: 15px;
  font-size: 14px;
  text-transform: uppercase;
}
.lookup-examples > ul {
  display: flex;
  list-style: none;
  padding: 0px;
  margin: 0px;
  width: 50%;
  flex-wrap: wrap;
}
.lookup-examples > ul li {
  flex: 1 1;
  padding: 0px;
}
.lookup-examples > ul li .label {
  display: flex;
  margin: 5px;
  line-height: inherit;
  font-size: 1.4rem;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}
.lookup-examples > ul li .label-default {
  background-color: #ffffff;
  color: #2661a5;
}
.lookup-examples > ul li a {
  text-decoration: none;
}

/*
 Pagination is handled pretty well by bootstrap.
 We add some minor extensions, like a breakable paginator.
*/
.pagination li.break a {
  border: none;
  border-left: 1px solid #ddd;
}
.pagination li.break a:hover {
  background: none;
}
.pagination .pagination-select {
  width: auto;
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 3px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  cursor: pointer;
  -moz-appearance: none;
  -webkit-appearance: none;
}
.pagination li.active .pagination-select {
  background-color: #337ab7;
  color: #fff;
}

.label-bgp-community {
  margin-right: 5px;
  display: inline-block;
}

.label-bgp-unknown {
  color: #333;
  background-color: #ddd;
}

/*
 * Filters
 */
.lookup-filters-editor h2 {
  color: #555;
  font-weight: bold;
  margin-top: 8px;
  margin-bottom: 5px;
  font-size: 12px;
  text-transform: uppercase;
  padding: 0;
}
.lookup-filters-editor .select-ctrl {
  width: 100%;
}
.lookup-filters-editor .select-ctrl .select-container {
  width: 100%;
}
.lookup-filters-editor .select-ctrl select {
  padding: 0px;
  width: 100%;
}
.lookup-filters-editor .select-ctrl td {
  padding-bottom: 5px;
  vertical-align: middle;
}
.lookup-filters-editor .select-ctrl .btn {
  margin-left: 3px;
  border-radius: 100px;
  padding: 3px 5px;
  font-size: 10px;
  line-height: 10px;
  color: #337ab7;
}
.lookup-filters-editor .select-ctrl .btn-remove {
  color: #aa0000;
}
.lookup-filters-editor .select-ctrl .options-title {
  font-weight: bold;
}
.lookup-filters-editor .select-ctrl .label {
  text-align: left;
  white-space: normal;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin: 16px 0 20px;
}

.summary-card {
  min-width: 0;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #0867af;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.summary-card-success {
  border-left-color: #16803c;
}

.summary-card-danger {
  border-left-color: #c62828;
}

.summary-card-warning {
  border-left-color: #b7791f;
}

.summary-card-label,
.summary-card-helper {
  display: block;
  color: #5f6b7a;
}

.summary-card-label {
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.035em;
  text-transform: uppercase;
}

.summary-card-value {
  display: block;
  overflow: hidden;
  color: #17202a;
  font-size: 26px;
  line-height: 1.15;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-card-helper {
  margin-top: 5px;
  font-size: 12px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  border-radius: 999px;
  background: #eef2f6;
  color: #465365;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}

.status-badge::before {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  content: "";
}

.status-badge-success {
  background: #e9f7ee;
  color: #137333;
}

.status-badge-danger {
  background: #fcebec;
  color: #b42318;
}

.status-badge-warning {
  background: #fff4df;
  color: #945d0b;
}

.data-legend {
  display: flex;
  align-items: center;
  gap: 8px 14px;
  flex-wrap: wrap;
  margin: 12px 0;
  color: #5f6b7a;
  font-size: 12px;
}

.data-legend-title {
  color: #344054;
  font-weight: 600;
}

@media (max-width: 600px) {
  .summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .summary-card {
    padding: 12px;
  }
  .summary-card-value {
    font-size: 22px;
  }
}
.traffic-controls {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin: 16px 0 8px;
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.traffic-control-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.traffic-control-label {
  margin-right: 4px;
  color: #344054;
  font-weight: 600;
}

.traffic-control-button {
  padding: 6px 12px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  background: #fff;
  color: #344054;
  cursor: pointer;
}

.traffic-control-button:hover {
  border-color: #0867af;
  color: #0867af;
}

.traffic-control-button.active {
  border-color: #0867af;
  background: #0867af;
  color: #fff;
}

.traffic-chart-card {
  min-height: 432px;
  padding: 16px 8px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.traffic-message {
  display: flex;
  min-height: 400px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #667085;
  text-align: center;
}

.traffic-error {
  color: #b42318;
}

.traffic-legend-dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  margin-right: 4px;
  border-radius: 50%;
}

.traffic-legend-rx {
  background: #16803c;
}

.traffic-legend-tx {
  background: #3187c9;
}

@media (max-width: 600px) {
  .traffic-controls,
  .traffic-control-group {
    align-items: stretch;
  }
  .traffic-controls {
    flex-direction: column;
  }
  .traffic-control-label {
    flex-basis: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/layouts/main.scss","webpack://./src/scss/main.scss","webpack://./src/scss/components/jumbotron.scss","webpack://./src/scss/components/sidebar.scss","webpack://./src/scss/components/status.scss","webpack://./src/scss/components/card.scss","webpack://./src/scss/components/modal.scss","webpack://./src/scss/components/neighbors.scss","webpack://./src/scss/components/routes.scss","webpack://./src/scss/components/error.scss","webpack://./src/scss/components/lookup.scss","webpack://./src/scss/components/pagination.scss","webpack://./src/scss/components/communities.scss","webpack://./src/scss/components/filter-editor.scss","webpack://./src/scss/components/summary.scss","webpack://./src/scss/components/traffic.scss"],"names":[],"mappings":"AAAA;;EAAA;AAKA;EACE,8BAAA;EACA,WAAA;EACA,YAAA;ACDF;;ADIA;;EAEE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;ACDF;;ADIA;EACE,WAAA;ACDF;;ADIA;EACE,gBAAA;ACDF;;ADIA;EACE,aAAA;EACA,SAAA;ACDF;;ADIA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,yDAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;ACDF;;ADIA;EACE,SAAA;ACDF;;ADIA;EACE,SAAA;EACA,YAAA;ACDF;ADGE;EACE,eAAA;EACA,qBAAA;ACDJ;;ADKA;EACE,eAAA;EACA,SAAA;EACA,mBAAA;ACFF;;ADMA;EACE,eAAA;EACA,gBAAA;ACHF;;ADOA;EACC;IACE,eAAA;IACA,gBAAA;ECJD;AACF;ADOA;EACE,UAAA;ACLF;;ADQA;EACE,gBAAA;EACA,mBAAA;ACLF;;ADSA;EACE,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;ACNF;;ADUI;EACI,cAAA;EACA,eAAA;EACA,aAAA;ACPR;;ADWA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ACRF;;ADWA;EAMI,iBAAA;EACA,gBAAA;ACbJ;ADOC;EACC,YAAA;EACA,iBAAA;ACLF;ADWI;EACI,WAAA;ACTR;;AC9GA;EACI,aAAA;EACA,4BAAA;ADiHJ;;AC9GA;EACG,aAAA;EACA,gBAAA;EACA,mBAAA;ADiHH;AChHG;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iCAAA;ADkHL;;AE/HA;;EAAA;AAIA;EACE,cAAA;AFiIF;AE/HE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EAEA,yBAAA;EAEA,kBAAA;AF+HJ;AE3HE;EACE,cAAA;EAEA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,YAAA;AF2HJ;AEzHI;EACE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;EACA,kBAAA;AF2HN;AEzHM;EACE,eAAA;AF2HR;AEvHI;EACE,SAAA;EACA,iBAAA;AFyHN;AEvHM;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AFyHR;AEvHM;EACE,eAAA;EACA,cAAA;AFyHR;AEnHE;EACE,gBAAA;AFqHJ;AEnHI;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AFqHN;AEpHQ;EACE,YAAA;EACA,kBAAA;EAEA,eAAA;AFqHV;AE9GI;EACE,eAAA;EACA,cAAA;AFgHN;AE7GI;EACE,qBAAA;AF+GN;AE7GM;EACE,0BAAA;AF+GR;AE1GM;EACE,eAAA;EACA,cAAA;AF4GR;AEzGM;EACE,eAAA;EACA,cAAA;AF2GR;AErGE;EACE,cAAA;EACA,gBAAA;AFuGJ;AEpGM;EACG,cAAA;AFsGT;AEjGQ;EACE,aAAA;AFmGV;AE/FY;EACI,aAAA;AFiGhB;AE5FI;EACG,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AF8FP;AE3FO;EACE,SAAA;EACA,SAAA;EACA,aAAA;AF6FT;AE3FO;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AF6FT;AE3FS;EACE,kBAAA;EACA,gBAAA;AF6FX;AE3FW;EACE,cAAA;AF6Fb;AEvFI;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AFyFN;AEvFM;EACE,YAAA;EACA,gBAAA;AFyFR;AEtFM;EAEE,mBAAA;EACA,YAAA;EACA,iBAAA;AFuFR;AEpFM;EACE,4BAAA;AFsFR;AElFI;EACI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AFoFR;AElFQ;EACI,gBAAA;EACA,qBAAA;AFoFZ;;AGpRA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AHuRF;AGrRE;EACE,iBAAA;AHuRJ;AGpRE;EACE,iBAAA;AHsRJ;AGnRE;EACE,iBAAA;EACA,gBAAA;AHqRJ;AGlRE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AHoRJ;AGjRE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AHmRJ;;AG/QA;EACE,WAAA;EACA,YAAA;AHkRF;AGjRE;EACE,mBAAA;EACA,YAAA;AHmRJ;AGjRI;EACE,WAAA;AHmRN;;AInUA;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;AJsUF;;AInUA;EACE,yBAAA;AJsUF;;AKhVA;;EAAA;AAIA;EACE,cAAA;ALkVF;AKhVE;EACE,kBAAA;ALkVJ;;AK7UI;EACE,gBAAA;EACA,gBAAA;ALgVN;;AK1UI;EACE,WAAA;EACA,eAAA;AL6UN;AK3UI;EACE,eAAA;EACA,WAAA;AL6UN;AKxUI;EACE,YAAA;AL0UN;;AKpUE;EACE,uBAAA;ALuUJ;;AM/WA;EACI,mBAAA;ANkXJ;AMjXI;EACI,WAAA;ANmXR;AMhXI;EACI,WAAA;ANkXR;;AM9WA;EACI,iBAAA;EACA,cAAA;ANiXJ;;AM9WA;EACI,iBAAA;EACA,iBAAA;ANiXJ;AMhXI;EACE,WAAA;ANkXN;AM/WI;EACI,YAAA;EACA,WAAA;EACA,qBAAA;ANiXR;AM/WI;EACI,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;ANiXR;AM/WQ;EACE,YAAA;ANiXV;AM9WQ;EACE,UAAA;ANgXV;;AM1WI;EACI,YAAA;AN6WR;AM1WI;EACI,UAAA;AN4WR;AOhZA;EACI;IACI,UAAA;IACA,WAlBW;EP+ajB;EO1ZE;IACI,UAAA;IACA,WAtBW;EPkbjB;AACF;AOpZE;EACE,kBAAA;APsZJ;AOnZE;EACE,cAAA;EACA,qBAAA;APqZJ;AOnZI;EACE,0BAAA;APqZN;AOlZI;EACI,eAAA;APoZR;AO9YE;;EAEE,cAAA;EACA,WAAA;EACA,kBAAA;APgZJ;AO9YI;;EACE,cAAA;APiZN;AO7YE;EAEE,iBAAA;EACA,WAAA;EAEA,mBAAA;AP6YJ;AO3YI;EACE,kBAAA;AP6YN;AOlYI;EACG,cAAA;APoYP;AOjYI;EACG,cAAA;APmYP;AOhYI;EACG,cAAA;APkYP;AO/XI;EACG,cAAA;APiYP;AO9XI;EACG,cAAA;APgYP;AO7XI;EACG,cAAA;AP+XP;AOxXE;EACE,WAAA;EACA,qBAAA;EACA,YAAA;EAEA,eAAA;EAEA,eAAA;EAEA,iBAAA;APuXJ;AOrXI;EACI,eAAA;EACA,aAAA;EAEA,WA5HW;EA6HX,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EAGA,0BAAA;APqXR;AOlXI;EACI,qBAAA;APoXR;AOnXQ;EACI,cAAA;EAGA,wBAAA;EAEA,yBAAA;APoXZ;AO9WE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;APgXJ;AO7WE;EACE,mBAAA;AP+WJ;;AO1WA;EAIE,iBAAA;AP0WF;AO7WE;EACE,mBAAA;AP+WJ;;AOxWI;EACI,sBAAA;EACA,eAAA;AP2WR;;AOvWA;EACI,qBAAA;AP0WJ;AOxWI;EACI,qBAAA;AP0WR;;AOrWA;EACI,iBAAA;EAEA,iBAAA;APuWJ;AOtWI;EACE,WAAA;APwWN;AOrWI;EACI,YAAA;EACA,WAAA;EACA,qBAAA;APuWR;AOrWI;EACI,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;APuWR;AOrWQ;EACE,aAAA;APuWV;AOpWQ;EACE,YAAA;APsWV;AOnWQ;EACE,UAAA;APqWV;;AO9VA;;EAAA;AAGA;EAII,cAAA;EACA,kBAAA;EACA,gBAAA;EAEA,wBAAA;EACA,WAAA;EAEA,gBAAA;EAEA,UAAA;AP2VJ;AOzVI;EACI,YAfQ;EAgBR,iBAhBQ;EAkBR,qBAAA;EAEA,gBAAA;EACA,wBAAA;EAEA,gCAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EAEA,4BAAA;APuVR;AOrVQ;EACI,iBAAA;APuVZ;AOtVY;EACI,cAAA;APwVhB;AOpVQ;EACI,qBAAA;APsVZ;;AOhVI;EACI,iBAAA;APmVR;;AO9UI;EACI,YAAA;APiVR;AO/UI;EACI,aAAA;APiVR;AO/UI;EACI,UAAA;APiVR;;AO1UY;EACI,aAAA;AP6UhB;AO/TA;EAEI;IACI,UAAA;IACA,WAAA;EPgUN;EO9TE;IACI,UAAA;IACA,WAAA;EPgUN;AACF;AO1TI;EACI,WAAA;EACA,iBAAA;EAEA,eAAA;EACA,kBAAA;EAEA,eAAA;EAEA,yBAAA;EAEA,UAAA;APwTR;AOrTI;EACI,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;APuTR;AOpTI;EACI,eAAA;EACA,WAAA;APsTR;AO9SI;EACI,WAAA;APgTR;AO9SI;EACI,iBAAA;APgTR;AO9SI;EACI,kBAAA;EACA,eAAA;APgTR;AO/SQ;EACI,YAAA;APiTZ;AO/SQ;EACI,YAAA;APiTZ;AO/SQ;EACI,aAAA;APiTZ;AOxSA;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;AP0SJ;;AOxSA;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AP2SJ;;AOzSA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,QAAA;EAAU,SAAA;EACV,6BAAA;EACA,mCAAA;EACA,kCAAA;AP6SJ;;AO3SA;EACI,mBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AP8SJ;;AQ5sBA;EACI,YAAA;EACA,gCAAA;EACA,sCAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AR+sBJ;AQ7sBI;EACE,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;AR+sBN;AQ7sBM;EACE,cAAA;EACA,mBAAA;AR+sBR;AQ3sBI;EACE,mBAAA;AR6sBN;AQ3sBM;EACE,gBAAA;EACA,eAAA;AR6sBR;AQzsBI;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AR2sBR;;AShvBI;EACI,yBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;ATmvBR;;AS7uBI;EACE,gBAAA;EACA,YAAA;EACA,WAAA;ATgvBN;AS7uBI;EACE,cAAA;AT+uBN;;AS1uBA;EACI,iBAAA;AT6uBJ;AS3uBI;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AT6uBR;ASnuBE;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;ATquBJ;ASnuBI;EACE,SAAA;EACA,YAAA;ATquBN;ASnuBM;EACE,aAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,wCAAA;ATquBR;ASluBM;EACE,yBAAA;EACA,cAAA;ATouBR;ASjuBM;EACE,qBAAA;ATmuBR;;AUxyBA;;;CAAA;AAOQ;EACI,YAAA;EACA,2BAAA;AVwyBZ;AUtyBY;EACI,gBAAA;AVwyBhB;AUnyBI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EAEA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,8BAAA;EAEA,eAAA;EAEA,qBAAA;EACA,wBAAA;AVkyBR;AU9xBQ;EACI,yBAAA;EACA,WAAA;AVgyBZ;;AWv0BA;EACE,iBAAA;EACA,qBAAA;AX00BF;;AWv0BA;EACI,WAAA;EACA,sBAAA;AX00BJ;;AYp1BA;;EAAA;AAKE;EACE,WAAA;EACA,iBAAA;EAEA,eAAA;EACA,kBAAA;EAEA,eAAA;EAEA,yBAAA;EAEA,UAAA;AZi1BJ;AY50BE;EACG,WAAA;AZ80BL;AY70BK;EACI,WAAA;AZ+0BT;AY70BK;EACI,YAAA;EACA,WAAA;AZ+0BT;AY70BK;EACG,mBAAA;EACA,sBAAA;AZ+0BR;AY70BK;EACI,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AZ+0BT;AY70BK;EACG,cAAA;AZ+0BR;AY50BK;EACG,iBAAA;AZ80BR;AY30BK;EACG,gBAAA;EACA,mBAAA;AZ60BR;;Aal4BA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;Abq4BF;;Aal4BA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;Abq4BF;;Aal4BA;EAAwB,0BAAA;Abs4BxB;;Aar4BA;EAAuB,0BAAA;Aby4BvB;;Aax4BA;EAAwB,0BAAA;Ab44BxB;;Aa14BA;;EAEE,cAAA;EACA,cAAA;Ab64BF;;Aa14BA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;Ab64BF;;Aa14BA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;Ab64BF;;Aa14BA;EACE,eAAA;EACA,eAAA;Ab64BF;;Aa14BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;Ab64BF;;Aa14BA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;Ab64BF;;Aa14BA;EACE,mBAAA;EACA,cAAA;Ab64BF;;Aa14BA;EACE,mBAAA;EACA,cAAA;Ab64BF;;Aa14BA;EACE,mBAAA;EACA,cAAA;Ab64BF;;Aa14BA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;Ab64BF;;Aa14BA;EACE,cAAA;EACA,gBAAA;Ab64BF;;Aa14BA;EACE;IACE,gDAAA;IACA,QAAA;Eb64BF;Ea14BA;IACE,aAAA;Eb44BF;Eaz4BA;IACE,eAAA;Eb24BF;AACF;Ac5/BA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;Ad8/BF;;Ac3/BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;Ad8/BF;;Ac3/BA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;Ad8/BF;;Ac3/BA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;Ad8/BF;;Ac3/BA;EACE,qBAAA;EACA,cAAA;Ad8/BF;;Ac3/BA;EACE,qBAAA;EACA,mBAAA;EACA,WAAA;Ad8/BF;;Ac3/BA;EACE,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;Ad8/BF;;Ac3/BA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;Ad8/BF;;Ac3/BA;EACE,cAAA;Ad8/BF;;Ac3/BA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;Ad8/BF;;Ac3/BA;EAAqB,mBAAA;Ad+/BrB;;Ac9/BA;EAAqB,mBAAA;AdkgCrB;;AchgCA;EACE;;IAEE,oBAAA;EdmgCF;EchgCA;IACE,sBAAA;EdkgCF;Ec//BA;IACE,gBAAA;EdigCF;AACF","sourcesContent":["/**\n * Main Layout Scss File \n */\n\n\nbody, html {\n  font-family: \"Source Sans Pro\";\n  margin: 0px;\n  padding: 0px;\n}\n\nbody,\n.page {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: row;\n  font-size: 1.4rem;\n}\n\n#app {\n  width: 100%;\n}\n\n.page header {\n  margin-top: 50px;\n}\n\n.page-body {\n  display: flex;\n  flex: 1;\n}\n\n.page-content {\n  display: flex;\n  flex: 1 0;\n  flex-direction: column;\n  background: #f4f5f7;\n  background-image: url('../../img/alicebg.png');\n  background-position: 95% 95%;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  padding: 0px;\n  margin: 0px;\n}\n\n.main-content-wrapper {\n  flex: 1;\n}\n\n.page-footer {\n  flex: 0 1;\n  padding: 3px;\n\n  a {\n    font-size: 12px;\n    text-decoration: none;\n  }\n}\n\n.page-nav {\n  flex: 0 0 250px;\n  order: -1;\n  background: #f8f8f8;\n  // border-right: 1px solid #ccc;\n}\n\n.page-sidebar {\n  flex: 0 0 195px;\n  background: #222;\n  // border-left: 1px solid #ccc;\n}\n\n@media (min-width: 1300px) {\n .page-sidebar {\n   flex: 0 0 230px;\n   background: #222;\n }\n}\n\nheader {\n  flex: none;\n}\n\n.navbar {\n  box-shadow: none;\n  border-bottom: none;\n}\n\n\n.page-header {\n  line-height: 59px;\n  background: white;\n  margin: 0px;\n  height: 59px;\n}\n\n.table-protocols {\n    .protocol-state-error {\n        display: block;\n        font-size: 11px;\n        color: orange;\n    }\n}\n\n.loading-indicator {\n  text-align: center;\n  width: 50px;\n  margin: 0px auto;\n}\n\n.details-main {\n\t.help-block {\n\t\tmargin: 20px;\n\t\tpadding: 10px 5px;\n\t}\n    \n    margin-right: 0px;\n    margin-top: 20px;\n\n    &.row {\n        margin: 0px;\n    }\n}\n\n\n","/**\n * Main Layout Scss File \n */\nbody, html {\n  font-family: \"Source Sans Pro\";\n  margin: 0px;\n  padding: 0px;\n}\n\nbody,\n.page {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: row;\n  font-size: 1.4rem;\n}\n\n#app {\n  width: 100%;\n}\n\n.page header {\n  margin-top: 50px;\n}\n\n.page-body {\n  display: flex;\n  flex: 1;\n}\n\n.page-content {\n  display: flex;\n  flex: 1 0;\n  flex-direction: column;\n  background: #f4f5f7;\n  background-image: url(\"../../img/alicebg.png\");\n  background-position: 95% 95%;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  padding: 0px;\n  margin: 0px;\n}\n\n.main-content-wrapper {\n  flex: 1;\n}\n\n.page-footer {\n  flex: 0 1;\n  padding: 3px;\n}\n.page-footer a {\n  font-size: 12px;\n  text-decoration: none;\n}\n\n.page-nav {\n  flex: 0 0 250px;\n  order: -1;\n  background: #f8f8f8;\n}\n\n.page-sidebar {\n  flex: 0 0 195px;\n  background: #222;\n}\n\n@media (min-width: 1300px) {\n  .page-sidebar {\n    flex: 0 0 230px;\n    background: #222;\n  }\n}\nheader {\n  flex: none;\n}\n\n.navbar {\n  box-shadow: none;\n  border-bottom: none;\n}\n\n.page-header {\n  line-height: 59px;\n  background: white;\n  margin: 0px;\n  height: 59px;\n}\n\n.table-protocols .protocol-state-error {\n  display: block;\n  font-size: 11px;\n  color: orange;\n}\n\n.loading-indicator {\n  text-align: center;\n  width: 50px;\n  margin: 0px auto;\n}\n\n.details-main {\n  margin-right: 0px;\n  margin-top: 20px;\n}\n.details-main .help-block {\n  margin: 20px;\n  padding: 10px 5px;\n}\n.details-main.row {\n  margin: 0px;\n}\n\n.jumbotron {\n  padding: 20px;\n  border-bottom: 3px solid red;\n}\n\n.central {\n  display: flex;\n  min-height: 75vh;\n  align-items: center;\n}\n.central h1 {\n  text-align: center;\n  flex: 1;\n  color: #777;\n  text-shadow: 0px -1px 0px #000000;\n}\n\n/*\n * HEADER\n */\n.page-sidebar {\n  color: #f0f0f0;\n}\n.page-sidebar h2 {\n  color: #b0b0b0;\n  margin-top: 15px;\n  font-size: 12px;\n  text-transform: uppercase;\n  padding-left: 15px;\n}\n.page-sidebar .sidebar-header {\n  color: #f0f0f0;\n  display: flex;\n  flex-direction: row;\n  background: #0867af;\n  justify-content: center;\n  align-items: center;\n  padding: 10px 15px;\n  height: 58px;\n}\n.page-sidebar .sidebar-header .logo {\n  flex: 0 0 50px;\n  padding: 10px 15px;\n  background-color: #222;\n  border-radius: 16px 16px 0px 0px;\n  margin-right: 12px;\n}\n.page-sidebar .sidebar-header .logo .logo-icon {\n  margin-top: 5px;\n}\n.page-sidebar .sidebar-header .title {\n  flex: 1;\n  padding-top: 10px;\n}\n.page-sidebar .sidebar-header .title h1 {\n  margin: 7px 0px 0px 0px;\n  padding: 3px 0px;\n  font-size: 13px;\n  color: #f0f0f0;\n}\n.page-sidebar .sidebar-header .title p {\n  font-size: 10px;\n  color: #f0f0f0;\n}\n.page-sidebar .routeservers-list {\n  margin-top: 40px;\n}\n.page-sidebar .routeservers-list > ul {\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n}\n.page-sidebar .routeservers-list > ul li {\n  padding: 8px;\n  padding-left: 15px;\n  cursor: pointer;\n}\n.page-sidebar .routeservers-list .routeserver-id {\n  font-size: 13px;\n  display: block;\n}\n.page-sidebar .routeservers-list a.routeserver-id {\n  text-decoration: none;\n}\n.page-sidebar .routeservers-list a.routeserver-id:hover {\n  text-decoration: underline;\n}\n.page-sidebar .routeservers-list .routeserver-status .bird-version {\n  font-size: 10px;\n  color: #888888;\n}\n.page-sidebar .routeservers-list .routeserver-status .api-error {\n  font-size: 10px;\n  color: #aa0000;\n}\n.page-sidebar .routeservers-groups-select {\n  display: block;\n  padding: 0px 3px;\n}\n.page-sidebar .routeservers-groups-select .dropdown .dropdown-menu {\n  display: block;\n}\n.page-sidebar .routeservers-groups-select .rs-group-dropdown .dropdown-options {\n  display: none;\n}\n.page-sidebar .routeservers-groups-select .rs-group-dropdown.open .dropdown-options {\n  display: flex;\n}\n.page-sidebar .routeservers-groups-select .dropdown-options {\n  position: absolute;\n  z-index: 999;\n  background: #fbfbfb;\n  border-radius: 4px;\n  box-shadow: 2px 2px 3px #aaa;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.page-sidebar .routeservers-groups-select .dropdown-options ul {\n  flex: 1;\n  margin: 0;\n  padding: 15px;\n}\n.page-sidebar .routeservers-groups-select .dropdown-options li {\n  padding: 3px;\n  list-style: none;\n  border-radius: 4px;\n}\n.page-sidebar .routeservers-groups-select .dropdown-options li button {\n  border-radius: 3px;\n  padding: 3px 8px;\n}\n.page-sidebar .routeservers-groups-select .dropdown-options li button:hover {\n  color: #337ab7;\n}\n.page-sidebar .routeservers-groups-select .btn-select {\n  display: block;\n  width: 100%;\n  background: #2661a5;\n  border: #2661a5;\n  text-align: left;\n  color: white;\n  text-shadow: none;\n}\n.page-sidebar .routeservers-groups-select .btn-select .caret {\n  float: right;\n  margin-top: 10px;\n}\n.page-sidebar .routeservers-groups-select .btn-select:focus, .page-sidebar .routeservers-groups-select .btn-select:hover {\n  background: #2661a5;\n  color: white;\n  text-shadow: none;\n}\n.page-sidebar .routeservers-groups-select .btn-select:focus {\n  box-shadow: 0px 1px 0px #555;\n}\n.page-sidebar .routeservers-groups-select .btn-option {\n  display: block;\n  text-align: left;\n  color: #2661a5;\n  width: 100%;\n  padding: 2px 10px;\n}\n.page-sidebar .routeservers-groups-select .btn-option:hover {\n  background: #ccc;\n  text-decoration: none;\n}\n\n.page-header {\n  display: flex;\n  align-items: center;\n  min-height: 72px;\n  height: auto;\n  padding: 12px 20px;\n  border-bottom: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n.page-header .status-name {\n  font-weight: bold;\n}\n.page-header .status-protocol {\n  font-weight: bold;\n}\n.page-header .spacer {\n  font-weight: bold;\n  padding: 0px 8px;\n}\n.page-header h1 {\n  margin: 0;\n  color: #17202a;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1.25;\n}\n.page-header p {\n  margin: 4px 0 0;\n  color: #667085;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.routeserver-status {\n  margin: 0px;\n  padding: 0px;\n}\n.routeserver-status td {\n  vertical-align: top;\n  padding: 4px;\n}\n.routeserver-status td i {\n  width: 15px;\n}\n\n.card {\n  position: relative;\n  background: white;\n  margin: 20px 0px 20px 0px;\n  border-radius: 2px;\n  box-shadow: 0px 1px 3px #cccccc;\n  padding: 15px;\n}\n\n.card-header {\n  text-transform: uppercase;\n}\n\n/**\n * Show Modal\n */\n.modal-show {\n  display: block;\n}\n.modal-show .modal-content {\n  border-radius: 3px;\n}\n\n.modal-dialog .modal-body {\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.bgp-attributes-modal .modal-header p {\n  margin: 0px;\n  font-size: 10px;\n}\n.bgp-attributes-modal .modal-header h4 {\n  font-size: 14px;\n  margin: 0px;\n}\n.bgp-attributes-modal table th {\n  width: 142px;\n}\n\n.table-nolines td, .table-nolines th {\n  border: none !important;\n}\n\n.col-neighbor-attr {\n  white-space: nowrap;\n}\n.col-neighbor-attr a, .col-neighbor-attr a:link, .col-neighbor-attr a:active {\n  color: #333;\n}\n.col-neighbor-attr i.fa {\n  color: #333;\n}\n\n.col-neighbor-active {\n  font-weight: bold;\n  color: #2e6da4;\n}\n\n.neighbors-quick-links {\n  margin: -0.75em 0;\n  text-align: right;\n}\n.neighbors-quick-links span {\n  color: #888;\n}\n.neighbors-quick-links ul {\n  padding: 0px;\n  margin: 0px;\n  display: inline-block;\n}\n.neighbors-quick-links li {\n  display: inline-block;\n  padding: 0px 4px;\n  margin: 0px 0px 0px 8px;\n  background: white;\n  border-radius: 3px;\n}\n.neighbors-quick-links li.established a {\n  color: green;\n}\n.neighbors-quick-links li.down a {\n  color: red;\n}\n\n.card-header-neighbors.established {\n  color: green;\n}\n.card-header-neighbors.down {\n  color: red;\n}\n\n@-webkit-keyframes fadeSmooth {\n  from {\n    opacity: 0;\n    left: -90px;\n  }\n  to {\n    opacity: 1;\n    left: -70px;\n  }\n}\n@keyframes fadeSmooth {\n  from {\n    opacity: 0;\n    left: -90px;\n  }\n  to {\n    opacity: 1;\n    left: -70px;\n  }\n}\n.table-routes tr {\n  position: relative;\n}\n.table-routes td {\n  color: #337ab7;\n  text-decoration: none;\n}\n.table-routes td span:hover {\n  text-decoration: underline;\n}\n.table-routes td span {\n  cursor: pointer;\n}\n.table-routes .noexport-reason,\n.table-routes .reject-reason {\n  font-size: 90%;\n  color: #333;\n  margin-bottom: 1px;\n}\n.table-routes .noexport-reason a,\n.table-routes .reject-reason a {\n  color: #aa0000;\n}\n.table-routes .col-route-flags {\n  padding-left: 2px;\n  width: auto;\n  white-space: nowrap;\n}\n.table-routes .col-route-flags i {\n  font-style: normal;\n}\n.table-routes .route-prefix-flags .primary-route {\n  color: #efb208;\n}\n.table-routes .route-prefix-flags .rpki-valid {\n  color: #009900;\n}\n.table-routes .route-prefix-flags .rpki-invalid {\n  color: #d80000;\n}\n.table-routes .route-prefix-flags .rpki-unknown {\n  color: #2e6da4;\n}\n.table-routes .route-prefix-flags .rpki-not-checked {\n  color: #2e6da4;\n}\n.table-routes .route-prefix-flags .reject-candidate-route {\n  color: #d80000;\n}\n.table-routes .route-prefix-flag {\n  color: #555;\n  text-decoration: none;\n  border: none;\n  font-size: 10px;\n  cursor: default;\n  padding-left: 3px;\n}\n.table-routes .route-prefix-flag div {\n  font-size: 12px;\n  display: none;\n  left: -90px;\n  background: rgba(0, 0, 0, 0.45);\n  color: white;\n  position: absolute;\n  padding: 5px;\n  margin-top: -22px;\n  border-radius: 3px;\n  font-weight: bold;\n  -webkit-animation-name: fadeSmooth;\n  animation-name: fadeSmooth;\n}\n.table-routes .route-prefix-flag:hover {\n  text-decoration: none;\n}\n.table-routes .route-prefix-flag:hover div {\n  display: block;\n  -webkit-animation-duration: 0.5s;\n  animation-duration: 0.5s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n.table-routes .route-network {\n  display: inline-block;\n  position: relative;\n  width: 100%;\n  white-space: nowrap;\n}\n.table-routes .route-age {\n  white-space: nowrap;\n}\n\n.table-protocols {\n  background: white;\n}\n.table-protocols .date-since {\n  white-space: nowrap;\n}\n\n.routes-loading.card p {\n  font-family: monospace;\n  font-size: 12px;\n}\n\n.routes-header-container {\n  text-decoration: none;\n}\n.routes-header-container a:hover {\n  text-decoration: none;\n}\n\n.routes-quick-links {\n  margin: -0.75em 0;\n  text-align: right;\n}\n.routes-quick-links span {\n  color: #888;\n}\n.routes-quick-links ul {\n  padding: 0px;\n  margin: 0px;\n  display: inline-block;\n}\n.routes-quick-links li {\n  display: inline-block;\n  padding: 0px 4px;\n  margin: 0px 0px 0px 8px;\n  background: white;\n  border-radius: 3px;\n}\n.routes-quick-links li.filtered a {\n  color: orange;\n}\n.routes-quick-links li.received a {\n  color: green;\n}\n.routes-quick-links li.not-exported a {\n  color: red;\n}\n\n/*\n * Related Peers\n */\n.related-peers {\n  display: block;\n  position: absolute;\n  overflow: hidden;\n  padding: 3px 3px 0px 3px;\n  margin: 0px;\n  list-style: none;\n  top: -26px;\n}\n.related-peers li {\n  height: 23px;\n  line-height: 23px;\n  display: inline-block;\n  padding: 0px 5px;\n  margin: 0px 10px 0px 0px;\n  border-bottom: 1px solid #ffffff;\n  background: #ffffff;\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n  box-shadow: 0px 1px 3px #aaa;\n}\n.related-peers li.active {\n  font-weight: bold;\n}\n.related-peers li.active a {\n  color: #2661a5;\n}\n.related-peers li a, .related-peers li a:hover {\n  text-decoration: none;\n}\n\n.has-related-peers .details-main {\n  padding-top: 21px;\n}\n\n.card-header-routes.received {\n  color: green;\n}\n.card-header-routes.filtered {\n  color: orange;\n}\n.card-header-routes.not-exported {\n  color: red;\n}\n\n.routes-view.routes-filtered .route-prefix-flag.reject-candidate-route {\n  display: none;\n}\n@media (min-width: 1200px) and (max-width: 1258px) {\n  .details-main > .col-main {\n    width: 80%;\n    float: left;\n  }\n  .details-main > .col-aside-details {\n    width: 20%;\n    float: left;\n  }\n}\n.card-related-peers h2 {\n  color: #555;\n  font-weight: bold;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-size: 12px;\n  text-transform: uppercase;\n  padding: 0;\n}\n.card-related-peers h3 {\n  font-size: 14px;\n  margin: 10px 0px 0px 0px;\n  padding-bottom: 2px;\n  border-bottom: 1px solid #ccc;\n  color: black;\n}\n.card-related-peers .related-peers-rs-peer {\n  margin: 5px 0px;\n  width: 100%;\n}\n.card-related-peers table {\n  width: 100%;\n}\n.card-related-peers .uptime {\n  text-align: right;\n}\n.card-related-peers .peer-stats {\n  text-align: center;\n  cursor: default;\n}\n.card-related-peers .peer-stats .routes-received {\n  color: green;\n}\n.card-related-peers .peer-stats .routes-accepted {\n  color: green;\n}\n.card-related-peers .peer-stats .routes-filtered {\n  color: orange;\n}\n.atooltip {\n  position: relative;\n  display: inline-block;\n  cursor: default;\n}\n\n.atooltip i {\n  position: absolute;\n  font-style: normal;\n  width: 140px;\n  color: #ffffff;\n  background: #000000;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  visibility: hidden;\n  border-radius: 6px;\n}\n\n.atooltip i:after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -8px;\n  width: 0;\n  height: 0;\n  border-top: 8px solid #000000;\n  border-right: 8px solid transparent;\n  border-left: 8px solid transparent;\n}\n\n.atooltip:hover i {\n  visibility: visible;\n  opacity: 0.8;\n  bottom: 30px;\n  left: 50%;\n  margin-left: -76px;\n  z-index: 999;\n}\n\n.error-notify {\n  width: 420px;\n  border-bottom: 7px solid #7c0002;\n  background-color: rgba(255, 0, 0, 0.8);\n  color: #fff;\n  border-radius: 2px;\n  padding: 16px;\n  position: fixed;\n  display: table;\n  z-index: 999;\n  right: 30px;\n  top: 20px;\n}\n.error-notify .error-icon {\n  display: table-cell;\n  width: 60px;\n  padding: 8px 10px 0 10px;\n  text-align: center;\n  vertical-align: top;\n}\n.error-notify .error-icon > i {\n  font-size: 3em;\n  border-radius: 100%;\n}\n.error-notify .error-message {\n  display: table-cell;\n}\n.error-notify .error-message > p {\n  line-height: 1.2;\n  margin-top: 6px;\n}\n.error-notify .error-dismiss {\n  position: absolute;\n  right: 5px;\n  top: 0px;\n  cursor: pointer;\n}\n\n.lookup-container h2 {\n  text-transform: uppercase;\n  color: #337ab7;\n  font-size: 14px;\n  line-height: 1;\n  margin-top: 0px;\n}\n\n.lookup-result-summary ul {\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n}\n.lookup-result-summary li {\n  padding: 5px 0;\n}\n\n.lookup-help {\n  margin: 30px 20px;\n}\n.lookup-help h3 {\n  font-weight: normal;\n  font-style: italic;\n  color: #337ab7;\n  margin-top: 15px;\n  font-size: 14px;\n  text-transform: uppercase;\n}\n.lookup-examples > ul {\n  display: flex;\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n  width: 50%;\n  flex-wrap: wrap;\n}\n.lookup-examples > ul li {\n  flex: 1;\n  padding: 0px;\n}\n.lookup-examples > ul li .label {\n  display: flex;\n  margin: 5px;\n  line-height: inherit;\n  font-size: 1.4rem;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);\n}\n.lookup-examples > ul li .label-default {\n  background-color: #ffffff;\n  color: #2661a5;\n}\n.lookup-examples > ul li a {\n  text-decoration: none;\n}\n\n/*\n Pagination is handled pretty well by bootstrap.\n We add some minor extensions, like a breakable paginator.\n*/\n.pagination li.break a {\n  border: none;\n  border-left: 1px solid #ddd;\n}\n.pagination li.break a:hover {\n  background: none;\n}\n.pagination .pagination-select {\n  width: auto;\n  position: relative;\n  float: left;\n  padding: 6px 12px;\n  margin-left: -1px;\n  line-height: 1.42857143;\n  color: #337ab7;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  cursor: pointer;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n.pagination li.active .pagination-select {\n  background-color: #337ab7;\n  color: #fff;\n}\n\n.label-bgp-community {\n  margin-right: 5px;\n  display: inline-block;\n}\n\n.label-bgp-unknown {\n  color: #333;\n  background-color: #ddd;\n}\n\n/*\n * Filters\n */\n.lookup-filters-editor h2 {\n  color: #555;\n  font-weight: bold;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-size: 12px;\n  text-transform: uppercase;\n  padding: 0;\n}\n.lookup-filters-editor .select-ctrl {\n  width: 100%;\n}\n.lookup-filters-editor .select-ctrl .select-container {\n  width: 100%;\n}\n.lookup-filters-editor .select-ctrl select {\n  padding: 0px;\n  width: 100%;\n}\n.lookup-filters-editor .select-ctrl td {\n  padding-bottom: 5px;\n  vertical-align: middle;\n}\n.lookup-filters-editor .select-ctrl .btn {\n  margin-left: 3px;\n  border-radius: 100px;\n  padding: 3px 5px;\n  font-size: 10px;\n  line-height: 10px;\n  color: #337ab7;\n}\n.lookup-filters-editor .select-ctrl .btn-remove {\n  color: #aa0000;\n}\n.lookup-filters-editor .select-ctrl .options-title {\n  font-weight: bold;\n}\n.lookup-filters-editor .select-ctrl .label {\n  text-align: left;\n  white-space: normal;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 12px;\n  margin: 16px 0 20px;\n}\n\n.summary-card {\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-left: 4px solid #0867af;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.summary-card-success {\n  border-left-color: #16803c;\n}\n\n.summary-card-danger {\n  border-left-color: #c62828;\n}\n\n.summary-card-warning {\n  border-left-color: #b7791f;\n}\n\n.summary-card-label,\n.summary-card-helper {\n  display: block;\n  color: #5f6b7a;\n}\n\n.summary-card-label {\n  margin-bottom: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.035em;\n  text-transform: uppercase;\n}\n\n.summary-card-value {\n  display: block;\n  overflow: hidden;\n  color: #17202a;\n  font-size: 26px;\n  line-height: 1.15;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.summary-card-helper {\n  margin-top: 5px;\n  font-size: 12px;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #465365;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.status-badge::before {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  content: \"\";\n}\n\n.status-badge-success {\n  background: #e9f7ee;\n  color: #137333;\n}\n\n.status-badge-danger {\n  background: #fcebec;\n  color: #b42318;\n}\n\n.status-badge-warning {\n  background: #fff4df;\n  color: #945d0b;\n}\n\n.data-legend {\n  display: flex;\n  align-items: center;\n  gap: 8px 14px;\n  flex-wrap: wrap;\n  margin: 12px 0;\n  color: #5f6b7a;\n  font-size: 12px;\n}\n\n.data-legend-title {\n  color: #344054;\n  font-weight: 600;\n}\n\n@media (max-width: 600px) {\n  .summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n  }\n  .summary-card {\n    padding: 12px;\n  }\n  .summary-card-value {\n    font-size: 22px;\n  }\n}\n.traffic-controls {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin: 16px 0 8px;\n  padding: 14px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.traffic-control-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.traffic-control-label {\n  margin-right: 4px;\n  color: #344054;\n  font-weight: 600;\n}\n\n.traffic-control-button {\n  padding: 6px 12px;\n  border: 1px solid #cfd7e3;\n  border-radius: 6px;\n  background: #fff;\n  color: #344054;\n  cursor: pointer;\n}\n\n.traffic-control-button:hover {\n  border-color: #0867af;\n  color: #0867af;\n}\n\n.traffic-control-button.active {\n  border-color: #0867af;\n  background: #0867af;\n  color: #fff;\n}\n\n.traffic-chart-card {\n  min-height: 432px;\n  padding: 16px 8px 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n}\n\n.traffic-message {\n  display: flex;\n  min-height: 400px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  color: #667085;\n  text-align: center;\n}\n\n.traffic-error {\n  color: #b42318;\n}\n\n.traffic-legend-dot {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  margin-right: 4px;\n  border-radius: 50%;\n}\n\n.traffic-legend-rx {\n  background: #16803c;\n}\n\n.traffic-legend-tx {\n  background: #3187c9;\n}\n\n@media (max-width: 600px) {\n  .traffic-controls,\n  .traffic-control-group {\n    align-items: stretch;\n  }\n  .traffic-controls {\n    flex-direction: column;\n  }\n  .traffic-control-label {\n    flex-basis: 100%;\n  }\n}","\n.jumbotron {\n    padding: 20px;\n    border-bottom: 3px solid red\n}\n\n.central {\n   display: flex;\n   min-height: 75vh; \n   align-items: center;\n   h1 {\n     text-align: center; \n     flex: 1;\n     color: #777;\n     text-shadow: 0px -1px 0px #000000; // 0px -1px 0px #000000;\n   }\n}\n\n","\n/*\n * HEADER\n */\n\n.page-sidebar {\n  color: #f0f0f0;\n\n  h2 {\n    color: #b0b0b0;\n    margin-top: 15px;\n    font-size: 12px;\n\n    text-transform: uppercase;\n\n    padding-left: 15px;\n  }\n\n\n  .sidebar-header {\n    color: #f0f0f0;\n\n    display: flex;\n    flex-direction: row;\n    background: #0867afff;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 15px;\n\n    height: 58px;\n\n    .logo {\n      flex: 0 0 50px;\n      padding: 10px 15px;\n      background-color: #222;\n      border-radius: 16px 16px 0px 0px;\n      margin-right: 12px;\n\n      .logo-icon {\n        margin-top: 5px;\n      }\n    }\n\n    .title {\n      flex: 1;\n      padding-top: 10px;\n\n      h1 {\n        margin: 7px 0px 0px 0px;\n        padding: 3px 0px;\n        font-size: 13px;\n        color: #f0f0f0;\n      }\n      p {\n        font-size: 10px;\n        color: #f0f0f0;\n      }\n    }\n  }\n\n\n  .routeservers-list {\n    margin-top: 40px;\n\n    > ul {\n      list-style: none;\n      padding: 0px;\n      margin: 0px;\n        li {\n          padding: 8px;\n          padding-left: 15px;\n\n          cursor: pointer;\n        }\n\n        li.active {\n        }\n    }\n\n    .routeserver-id {\n      font-size: 13px;\n      display: block;\n    }\n\n    a.routeserver-id {\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    .routeserver-status {\n      .bird-version {\n        font-size: 10px;\n        color: #888888;\n      }\n\n      .api-error {\n        font-size: 10px;\n        color: #aa0000;\n      }\n    }\n\n  }\n\n  .routeservers-groups-select {\n    display: block;\n    padding: 0px 3px;\n    \n    .dropdown {\n      .dropdown-menu {\n         display: block;\n      }\n    }\n\n    .rs-group-dropdown {\n        .dropdown-options {\n          display: none;\n        }\n\n        &.open {\n            .dropdown-options {\n                display: flex;\n            }\n        }\n    }\n\n    .dropdown-options {\n       position: absolute;\n       z-index: 999;\n       background: #fbfbfb;\n       border-radius: 4px;\n       box-shadow: 2px 2px 3px #aaa;\n       flex-direction: row;\n       justify-content: space-between;\n       flex-wrap: wrap;\n       // column-gap: 15px;\n\n       ul {\n         flex: 1;\n         margin: 0;\n         padding: 15px;\n       }\n       li {\n         padding: 3px;\n         list-style: none;\n         border-radius: 4px;\n\n         button {\n           border-radius: 3px;\n           padding: 3px 8px; \n\n           &:hover {\n             color: #337ab7;\n           }\n         }\n       }\n    }\n\n    .btn-select {\n      display: block;\n      width: 100%;\n      background: #2661a5;\n      border: #2661a5;\n      text-align: left;\n      color: white;\n      text-shadow: none;\n\n      .caret {\n        float: right;\n        margin-top: 10px;\n      }\n\n      &:focus,\n      &:hover {\n        background: #2661a5;\n        color: white;\n        text-shadow: none;\n      }\n\n      &:focus {\n        box-shadow: 0px 1px 0px #555;\n      }\n    }\n    \n    .btn-option {\n        display: block;\n        text-align: left;\n        color: #2661a5;\n        width: 100%;\n        padding: 2px 10px;\n\n        &:hover {\n            background: #ccc;\n            text-decoration: none;\n        }\n    }\n\n\n  }\n\n}\n","\n\n\n.page-header {\n  display: flex;\n  align-items: center;\n  min-height: 72px;\n  height: auto;\n  padding: 12px 20px;\n  border-bottom: 1px solid #e2e8f0;\n  border-radius: 8px;\n\n  .status-name {\n    font-weight: bold;\n  }\n\n  .status-protocol {\n    font-weight: bold;\n  }\n\n  .spacer {\n    font-weight: bold;\n    padding: 0px 8px;\n  }\n\n  h1 {\n    margin: 0;\n    color: #17202a;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 1.25;\n  }\n\n  p {\n    margin: 4px 0 0;\n    color: #667085;\n    font-size: 14px;\n    line-height: 1.4;\n  }\n}\n\n.routeserver-status {\n  margin: 0px;\n  padding: 0px;\n  td {\n    vertical-align: top;\n    padding: 4px;\n\n    i {\n      width: 15px;\n    }\n  }\n}\n\n","\n.card {\n  position: relative;\n  background: white;\n  margin: 20px 0px 20px 0px;\n  border-radius: 2px;\n  box-shadow: 0px 1px 3px #cccccc;\n  padding: 15px;\n}\n\n.card-header {\n  text-transform: uppercase;\n}\n\n","\n/**\n * Show Modal\n */\n\n.modal-show {\n  display: block;\n\n  .modal-content {\n    border-radius: 3px;\n  }\n}\n\n.modal-dialog {\n    .modal-body {\n      max-height: 70vh;\n      overflow-y: auto;\n    }\n}\n\n.bgp-attributes-modal {\n  .modal-header {\n    p {\n      margin: 0px;\n      font-size: 10px;\n    }\n    h4 {\n      font-size: 14px;\n      margin: 0px;\n    }\n  }\n\n  table {\n    th {\n      width: 142px;\n    }\n  }\n}\n\n.table-nolines {\n  td, th {\n    border: none !important;\n  }\n}\n\n","\n.col-neighbor-attr {\n    white-space: nowrap;\n    a, a:link, a:active {\n        color: #333;\n    }\n\n    i.fa {\n        color: #333;\n    }\n}\n\n.col-neighbor-active {\n    font-weight: bold;\n    color: #2e6da4;\n}\n\n.neighbors-quick-links {\n    margin: -0.75em 0; \n    text-align: right;\n    span {\n      color: #888;\n    }\n\n    ul {\n        padding: 0px;\n        margin: 0px;\n        display: inline-block;\n    }\n    li {\n        display: inline-block;\n        padding: 0px 4px;\n        margin: 0px 0px 0px 8px;\n        background: white;\n        border-radius: 3px;\n\n        &.established a {\n          color: green;\n        }\n\n        &.down a {\n          color: red;\n        }\n    }\n}\n\n.card-header-neighbors {\n    &.established {\n        color: green;\n    }\n\n    &.down {\n        color: red;\n    }\n}\n\n","\n$labelOffsetStart: -90px;\n$labelOffsetEnd:   -70px;\n\n\n@-webkit-keyframes fadeSmooth {\n    from {\n        opacity: 0;\n        left: $labelOffsetStart;\n    }\n\n    to {\n        opacity: 1;\n        left: $labelOffsetEnd;\n    }\n}\n@keyframes fadeSmooth {\n    from {\n        opacity: 0;\n        left: $labelOffsetStart;\n    }\n\n    to {\n        opacity: 1;\n        left: $labelOffsetEnd;\n    }\n}\n                                   \n.fadeIn {\n}\n\n\n.table-routes {\n  tr {\n    position: relative; // anchor\n  }\n\n  td {\n    color: #337ab7;\n    text-decoration: none;\n\n    span:hover {\n      text-decoration: underline;\n    }\n\n    span {\n        cursor: pointer;\n    }\n\n  }\n\n\n  .noexport-reason,\n  .reject-reason {\n    font-size: 90%;\n    color: #333;\n    margin-bottom: 1px;\n\n    a {\n      color: #aa0000;\n    }\n  }\n\n  .col-route-flags {\n    // padding: 7px 0px;\n    padding-left: 2px;\n    width: auto;\n\n    white-space: nowrap;\n\n    i {\n      font-style: normal;\n    }\n  }\n\n  .col-route-network {\n    // padding: 8px 0px;\n    // padding-left: 3px;\n\n  }\n\n  .route-prefix-flags {\n    .primary-route {\n       color: #efb208; \n    }\n\n    .rpki-valid {\n       color: #009900;\n    }\n    \n    .rpki-invalid {\n       color: #d80000;\n    }\n\n    .rpki-unknown {\n       color: #2e6da4;\n    }\n\n    .rpki-not-checked {\n       color: #2e6da4;\n    }\n\n    .reject-candidate-route {\n       color: #d80000;\n    }\n  }\n\n  .route-prefix-flags {\n  }\n\n  .route-prefix-flag {\n    color: #555;\n    text-decoration: none;\n    border: none;\n\n    font-size: 10px;\n\n    cursor: default;\n\n    padding-left: 3px;\n\n    div {\n        font-size: 12px;\n        display: none;\n        // top: -5px;\n        left: $labelOffsetStart;\n        background: rgba(0, 0, 0, 0.45);\n        color: white;\n        position: absolute;\n        padding: 5px;\n        margin-top: -22px;\n        border-radius: 3px;\n        font-weight: bold;\n\n        -webkit-animation-name: fadeSmooth;\n        animation-name: fadeSmooth;\n    }\n\n    &:hover {\n        text-decoration: none;\n        div {\n            display: block;\n\n            -webkit-animation-duration: 0.5s;\n            animation-duration: 0.5s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n        }\n    }\n\n  }\n\n  .route-network {\n    display: inline-block;\n    position: relative;\n    width: 100%;\n    white-space: nowrap;\n  }\n\n  .route-age {\n    white-space: nowrap;\n  }\n}\n\n\n.table-protocols {\n  .date-since {\n    white-space: nowrap;\n  }\n  background: white;\n}\n\n\n.routes-loading.card {\n    p {\n        font-family: monospace;\n        font-size: 12px;\n    }\n}\n\n.routes-header-container {\n    text-decoration: none;\n\n    a:hover {\n        text-decoration: none;\n    }\n}\n\n\n.routes-quick-links {\n    margin: -0.75em 0; \n\n    text-align: right;\n    span {\n      color: #888;\n    }\n\n    ul {\n        padding: 0px;\n        margin: 0px;\n        display: inline-block;\n    }\n    li {\n        display: inline-block;\n        padding: 0px 4px;\n        margin: 0px 0px 0px 8px;\n        background: white;\n        border-radius: 3px;\n\n        &.filtered a {\n          color: orange;\n        }\n\n        &.received a {\n          color: green;\n        }\n\n        &.not-exported a {\n          color: red;\n        }\n    }\n\n}\n\n\n/*\n * Related Peers\n */\n.related-peers {\n    $tabHeight: 23px;\n    $shadowOffset: 3px;\n\n    display: block;\n    position: absolute; \n    overflow: hidden;\n\n    padding: $shadowOffset $shadowOffset 0px $shadowOffset;\n    margin: 0px;\n    \n    list-style: none;\n\n    top: -$tabHeight - $shadowOffset;\n\n    li {\n        height: $tabHeight;\n        line-height: $tabHeight;\n\n        display: inline-block;\n\n        padding: 0px 5px;\n        margin: 0px 10px 0px 0px;\n        \n        border-bottom: 1px solid #ffffff;\n        background: #ffffff;\n        border-top-left-radius: 2px;\n        border-top-right-radius: 2px;\n\n        box-shadow: 0px 1px 3px #aaa;\n\n        &.active {\n            font-weight: bold;\n            a {\n                color: #2661a5;\n            }\n        }\n\n        a, a:hover {\n            text-decoration: none;     \n        }\n    }\n}\n\n.has-related-peers {\n    .details-main {\n        padding-top: 21px;\n    }\n}\n\n.card-header-routes {\n    &.received {\n        color: green;\n    }\n    &.filtered {\n        color: orange;\n    }\n    &.not-exported {\n        color: red;\n    }\n}\n\n.routes-view {\n    &.routes-filtered {\n        .route-prefix-flag {\n            &.reject-candidate-route {\n                display: none;\n            }\n        }\n    }\n\n    &.routes-received {\n        .table-routes {\n            .reject-reason {\n            }\n        }\n    }\n}\n\n// Responsive tweaks: The awkward inbetween.\n@media (min-width: 1200px) and (max-width: 1258px) {\n  .details-main {\n    > .col-main {\n        width: 80%;\n        float: left;\n    }\n    > .col-aside-details {\n        width: 20%;\n        float: left;\n    }\n  }\n}\n\n// Related Peers Box\n.card-related-peers {\n    h2 {\n        color: #555;\n        font-weight: bold;\n\n        margin-top: 8px;\n        margin-bottom: 5px;\n\n        font-size: 12px;\n\n        text-transform: uppercase;\n\n        padding: 0;\n    }\n\n    h3 {\n        font-size: 14px;\n        margin: 10px 0px 0px 0px;\n        padding-bottom: 2px;\n        border-bottom: 1px solid #ccc;\n        color: black;\n    }\n\n    .related-peers-rs-peer {\n        margin: 5px 0px;\n        width: 100%;\n        td {\n        }\n    }\n}\n\n\n.card-related-peers {\n    table {\n        width: 100%;\n    }\n    .uptime {\n        text-align: right;\n    }\n    .peer-stats {\n        text-align: center;\n        cursor: default;\n        .routes-received {\n            color: green;\n        }\n        .routes-accepted {\n            color: green;\n        }\n        .routes-filtered {\n            color: orange;\n        }\n        .routes-exported {\n            \n        }\n    }\n}\n\n\n.atooltip {\n    position: relative;\n    display: inline-block;\n    cursor: default;\n}\n.atooltip i {\n    position: absolute;\n    font-style: normal;\n    width:140px;\n    color: #ffffff;\n    background: #000000;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    visibility: hidden;\n    border-radius: 6px;\n}\n.atooltip i:after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -8px;\n    width: 0; height: 0;\n    border-top: 8px solid #000000;\n    border-right: 8px solid transparent;\n    border-left: 8px solid transparent;\n}\n.atooltip:hover i {\n    visibility: visible;\n    opacity: 0.8;\n    bottom: 30px;\n    left: 50%;\n    margin-left: -76px;\n    z-index: 999;\n}\n\n\n",".error-notify {\n    width: 420px;\n    border-bottom: 7px solid #7c0002;\n    background-color: rgba(255,0,0,0.8);\n    color: #fff;\n    border-radius: 2px;\n    padding: 16px;\n    position: fixed;\n    display: table;\n    z-index: 999;\n    right: 30px;\n    top: 20px;\n\n    .error-icon {\n      display: table-cell;\n      width: 60px;\n      padding: 8px 10px 0 10px;\n      text-align: center;\n      vertical-align: top;\n\n      > i {\n        font-size: 3em;\n        border-radius: 100%;\n      }\n    }\n\n    .error-message{\n      display: table-cell;\n\n      > p {\n        line-height: 1.2;\n        margin-top: 6px;\n      }\n    }\n\n    .error-dismiss {\n        position: absolute;\n        right: 5px;\n        top: 0px;\n        cursor: pointer;\n    }\n}\n","\n.lookup-container {\n    h2 {\n        text-transform: uppercase;\n        color: #337ab7;\n        font-size: 14px;\n        line-height: 1;\n        margin-top: 0px;\n    }\n}\n\n\n.lookup-result-summary {\n    ul {\n      list-style: none;\n      padding: 0px;\n      margin: 0px;\n    }\n\n    li {\n      padding: 5px 0;\n    }\n}\n\n\n.lookup-help {\n    margin: 30px 20px;\n\n    h3 {\n        font-weight: normal;\n        font-style: italic;\n        color: #337ab7;\n        margin-top: 15px;\n        font-size: 14px;\n        text-transform: uppercase;\n    }\n\n    b {\n\n    }\n}\n\n.lookup-examples {\n  \n  > ul {\n    display: flex;\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n    width: 50%;\n    flex-wrap: wrap;\n\n    li {\n      flex: 1;\n      padding: 0px;\n\n      .label {\n        display: flex;\n        margin: 5px;\n        line-height: inherit;\n        font-size: 1.4rem;\n        box-shadow: 0 1px 1px rgba(0,0,0,.2);\n      }\n\n      .label-default {\n        background-color: #ffffff;\n        color: #2661a5;\n      }\n\n      a {\n        text-decoration: none;\n      }\n    }\n  }\n}\n\n","\n/*\n Pagination is handled pretty well by bootstrap.\n We add some minor extensions, like a breakable paginator.\n*/\n\n.pagination {\n    li.break {\n        a {\n            border: none;\n            border-left: 1px solid #ddd;\n\n            &:hover {\n                background: none;\n            }\n        }\n    }\n\n    .pagination-select {\n        width: auto;\n        position: relative;\n        float: left;\n        padding: 6px 12px;\n        margin-left: -1px;\n        line-height: 1.42857143;\n        color: #337ab7;\n        text-decoration: none;\n\n        background-color: #fff;\n        border: 1px solid #ddd;\n        border-radius: 3px;\n        border-top-left-radius: 0px;\n        border-bottom-left-radius: 0px;\n\n        cursor: pointer;\n\n        -moz-appearance: none;\n        -webkit-appearance: none\n    }\n\n    li.active {\n        .pagination-select {\n            background-color: #337ab7;\n            color: #fff;\n        }\n    }\n}\n\n","\n// BGP Communities Labels\n\n\n.label-bgp-community {\n  margin-right: 5px;\n  display: inline-block;\n}\n\n.label-bgp-unknown {\n    color: #333;\n    background-color: #ddd;\n}\n\n\n","\n/*\n * Filters\n */\n\n.lookup-filters-editor {\n  h2 {\n    color: #555;\n    font-weight: bold;\n\n    margin-top: 8px;\n    margin-bottom: 5px;\n\n    font-size: 12px;\n\n    text-transform: uppercase;\n\n    padding: 0;\n  }\n\n    \n  // Select Control\n  .select-ctrl {\n     width: 100%;\n     .select-container {\n         width: 100%;\n     }\n     select {\n         padding: 0px;\n         width: 100%;\n     }\n     td {\n        padding-bottom: 5px;\n        vertical-align: middle;\n     }\n     .btn {\n         margin-left: 3px;\n         border-radius: 100px;\n         padding: 3px 5px;\n         font-size: 10px;\n         line-height: 10px;\n         color: #337ab7;\n     }\n     .btn-remove {\n        color: #aa0000;\n     }\n\n     .options-title {\n        font-weight: bold;\n     }\n\n     .label {\n        text-align: left;\n        white-space: normal;\n     }\n  }\n\n}\n\n",".summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 12px;\n  margin: 16px 0 20px;\n}\n\n.summary-card {\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-left: 4px solid #0867af;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.summary-card-success { border-left-color: #16803c; }\n.summary-card-danger { border-left-color: #c62828; }\n.summary-card-warning { border-left-color: #b7791f; }\n\n.summary-card-label,\n.summary-card-helper {\n  display: block;\n  color: #5f6b7a;\n}\n\n.summary-card-label {\n  margin-bottom: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: .035em;\n  text-transform: uppercase;\n}\n\n.summary-card-value {\n  display: block;\n  overflow: hidden;\n  color: #17202a;\n  font-size: 26px;\n  line-height: 1.15;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.summary-card-helper {\n  margin-top: 5px;\n  font-size: 12px;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #465365;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.status-badge::before {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  content: \"\";\n}\n\n.status-badge-success {\n  background: #e9f7ee;\n  color: #137333;\n}\n\n.status-badge-danger {\n  background: #fcebec;\n  color: #b42318;\n}\n\n.status-badge-warning {\n  background: #fff4df;\n  color: #945d0b;\n}\n\n.data-legend {\n  display: flex;\n  align-items: center;\n  gap: 8px 14px;\n  flex-wrap: wrap;\n  margin: 12px 0;\n  color: #5f6b7a;\n  font-size: 12px;\n}\n\n.data-legend-title {\n  color: #344054;\n  font-weight: 600;\n}\n\n@media (max-width: 600px) {\n  .summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n  }\n\n  .summary-card {\n    padding: 12px;\n  }\n\n  .summary-card-value {\n    font-size: 22px;\n  }\n}\n",".traffic-controls {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin: 16px 0 8px;\n  padding: 14px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.traffic-control-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.traffic-control-label {\n  margin-right: 4px;\n  color: #344054;\n  font-weight: 600;\n}\n\n.traffic-control-button {\n  padding: 6px 12px;\n  border: 1px solid #cfd7e3;\n  border-radius: 6px;\n  background: #fff;\n  color: #344054;\n  cursor: pointer;\n}\n\n.traffic-control-button:hover {\n  border-color: #0867af;\n  color: #0867af;\n}\n\n.traffic-control-button.active {\n  border-color: #0867af;\n  background: #0867af;\n  color: #fff;\n}\n\n.traffic-chart-card {\n  min-height: 432px;\n  padding: 16px 8px 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, .08);\n}\n\n.traffic-message {\n  display: flex;\n  min-height: 400px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  color: #667085;\n  text-align: center;\n}\n\n.traffic-error {\n  color: #b42318;\n}\n\n.traffic-legend-dot {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  margin-right: 4px;\n  border-radius: 50%;\n}\n\n.traffic-legend-rx { background: #16803c; }\n.traffic-legend-tx { background: #3187c9; }\n\n@media (max-width: 600px) {\n  .traffic-controls,\n  .traffic-control-group {\n    align-items: stretch;\n  }\n\n  .traffic-controls {\n    flex-direction: column;\n  }\n\n  .traffic-control-label {\n    flex-basis: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
